var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFairtransportEmblem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.63, 13.63) scale(4.773)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.97,
    cy: 23.97,
    r: 23.89,
    fill: "#006259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.97,47.95C10.75,47.95,0,37.19,0,23.97S10.75,0,23.97,0s23.97,10.75,23.97,23.97-10.75,23.97-23.97,23.97ZM23.97.17C10.85.17.17,10.85.17,23.97s10.68,23.8,23.8,23.8,23.8-10.68,23.8-23.8S37.09.17,23.97.17Z",
    fill: "#006259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.05,1.29c-2.87,0-6.01.69-9.06,2.14C5.87,7.27,1.48,15,4.18,20.68c1.68,3.55,5.74,5.47,10.52,5.47,2.87,0,6.01-.69,9.06-2.14,8.12-3.85,12.51-11.58,9.81-17.26-1.68-3.55-5.73-5.47-10.52-5.47Z",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2,12.69l.55-12.36c-.74.04-1.46.1-2.18.21l-2.02,12.15h3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.51,30.9l-2.37,14.22c2.31,1.18,4.84,1.98,7.51,2.35l.74-16.57h-5.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.08,12.69L27.05.51c-.73-.1-1.48-.16-2.23-.19l.43,12.37h3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.89,30.9l.58,16.64c2.85-.31,5.55-1.13,8-2.36l-2.37-14.28h-6.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.21,21.19v-5.8h2.89v.98h-1.78v1.33h1.4v.98h-1.4v2.51h-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.61,21.19l1.44-5.8h1.42l1.4,5.8h-1.06l-.28-1.22h-1.54l-.31,1.22h-1.07ZM22.2,18.99h1.1l-.54-2.35h-.02l-.55,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.77,21.19v-5.8h1.11v5.8h-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.47,22.55v.98h-1.29v4.82h-1.11v-4.82h-1.29v-.98h3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.67,28.35l1.44-5.8h1.42l1.4,5.8h-1.06l-.28-1.22h-1.54l-.31,1.22h-1.07ZM14.26,26.15h1.1l-.54-2.35h-.02l-.55,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.83,28.35v-5.8h1.21l1.54,3.44h.02v-3.44h1.01v5.8h-1.06l-1.7-3.75h-.02v3.75h-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.36,24.17c-.18-.55-.43-.78-.81-.78s-.61.24-.61.64c0,.88,2.48.94,2.48,2.76,0,1-.68,1.66-1.85,1.66-.9,0-1.6-.49-1.9-1.63l1.09-.23c.13.7.53.95.86.95.39,0,.68-.26.68-.69,0-1.09-2.48-1.11-2.48-2.73,0-1,.59-1.62,1.74-1.62.99,0,1.59.59,1.78,1.41l-1,.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.68,28.35v-5.8h1.6c1.37,0,2.03.64,2.03,1.74s-.67,1.74-2.03,1.74h-.49v2.33h-1.11ZM28.79,25.11h.59c.55,0,.82-.27.82-.82s-.27-.82-.82-.82h-.59v1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.22,24.42c0-1.43.76-1.95,1.83-1.95s1.83.51,1.83,1.95v2.07c0,1.43-.76,1.95-1.83,1.95s-1.83-.51-1.83-1.95v-2.07ZM33.33,26.63c0,.64.28.82.72.82s.72-.18.72-.82v-2.36c0-.64-.28-.82-.72-.82s-.72.18-.72.82v2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.08,22.55v.98h-1.29v4.82h-1.11v-4.82h-1.29v-.98h3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.02,25.59c.37-.28.57-.71.57-1.26,0-1.09-.63-1.74-1.97-1.74h-1.61v5.8h1.11v-2.29h.53c.49,0,.83.15.83.72,0,.01,0,.03,0,.04,0,0,0,0,0,0l.03,1.53h1.13s-.1-1.74-.1-1.74c-.02-.42-.16-.7-.4-.91-.05-.05-.15-.09-.19-.12,0,0,.07-.05.08-.05ZM38.12,23.51h.57c.49,0,.79.24.79.8s-.3.8-.79.8h-.57v-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.35,25.54c.37-.28.57-.71.57-1.26,0-1.09-.63-1.74-1.97-1.74h-1.61v5.8h1.11v-2.29h.53c.49,0,.83.15.83.72,0,.01,0,.03,0,.04,0,0,0,0,0,0l.03,1.53h1.13s-.1-1.74-.1-1.74c-.02-.42-.16-.7-.4-.91-.05-.05-.15-.09-.19-.12,0,0,.07-.05.08-.05ZM9.45,23.47h.57c.49,0,.79.24.79.8s-.3.8-.79.8h-.57v-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.16,18.38c.37-.28.57-.71.57-1.26,0-1.09-.63-1.74-1.97-1.74h-1.61v5.8h1.11v-2.29h.53c.49,0,.83.15.83.72,0,.01,0,.03,0,.04,0,0,0,0,0,0l.03,1.53h1.13s-.1-1.74-.1-1.74c-.02-.42-.16-.7-.4-.91-.05-.05-.15-.09-.19-.12,0,0,.07-.05.08-.05ZM29.27,16.3h.57c.49,0,.79.24.79.8s-.3.8-.79.8h-.57v-1.61Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFairtransportEmblem);
export default __webpack_public_path__ + "static/media/fairtransport-emblem.21695a5eb78b75d266c9bbc1f14420fa.svg";
export { ForwardRef as ReactComponent };